<accredible-two-columns-layout
  class="reset-password-container"
  *transloco="let t; read: 'reset-password'"
  backgroundImage="'/assets/images/two-columns-layout-component/layout-purple.png'">
  <div leftColumn>
    <acs-cta-panel />
  </div>
  <div rightColumn class="right-column">
    <accredible-top-border-card>
      <div class="header">
        <img src="/assets/images/accredible-new-logo.svg" alt="" />
        @if (!isPasswordSaved()) {
          <div class="text">
            <h1 [innerHTML]="t('form.title')"></h1>
            <h2>{{ t('form.subtitle') }}</h2>
          </div>
        }
      </div>
      @if (!isPasswordSaved()) {
        <form
          class="main-panel-form"
          autocomplete="off"
          [formGroup]="formGroup"
          (ngSubmit)="submit()">
          <div class="row-xs align-middle form-row">
            <accredible-text-input
              type="password"
              [formControlRef]="getFormControl(formGroup, 'newPassword')"
              [label]="t('form.newPassword.label')"
              [autoComplete]="'new-password'">
              @if (getFormControl(formGroup, 'newPassword').hasError('required')) {
                <span [innerHTML]="t('form.newPassword.errors.required')"></span>
              }
              @if (getFormControl(formGroup, 'newPassword').hasError('password')) {
                <span [innerHTML]="t('form.newPassword.errors.invalid')"> </span>
              }
            </accredible-text-input>
          </div>

          <div class="row-xs align-middle form-row">
            <accredible-text-input
              type="password"
              [formControlRef]="getFormControl(formGroup, 'confirmPassword')"
              [label]="t('form.confirmPassword.label')"
              [autoComplete]="'new-password'">
              @if (getFormControl(formGroup, 'confirmPassword').hasError('required')) {
                <span [innerHTML]="t('form.confirmPassword.errors.required')"> </span>
              }
              @if (getFormControl(formGroup, 'confirmPassword').hasError('mustMatch')) {
                <span [innerHTML]="t('form.confirmPassword.errors.must_match')"> </span>
              }
            </accredible-text-input>
          </div>

          <accredible-button-loading
            [btnType]="'submit'"
            [isLoading]="isLoading()"
            [size]="'large'"
            [btnText]="t('form.reset_password')">
          </accredible-button-loading>
        </form>
      } @else {
        <div class="password-saved">
          <h1 [innerHTML]="t('password_saved.title')"></h1>

          <acs-email-sent
            [status]="'succeeded'"
            [subtitle]="t('password_saved.subtitle')"
            [routerLinkAction]="routerLinkAction">
          </acs-email-sent>
        </div>
      }
    </accredible-top-border-card>
  </div>
</accredible-two-columns-layout>
